import React from 'react';
import { Formik, Field, Form } from 'formik';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { Card, Typography } from '@material-ui/core';
import { InputContainer, InputItem } from 'components/form/StyledComponents';
import CustomTextField from 'components/form/components/CustomTextField';
import FormButtons from 'components/form/components/FormButtons';
import CustomSelect from 'components/form/components/CustomSelect';

const TabContainer = ({ children }) => {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {children}
    </Typography>
  );
};

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

export const formInitialValues = {
  id: '',
  name: '',
  status: 0,
};

const schema = Yup.object().shape({
  id: Yup.number(),
  name: Yup.string().required('Este campo é obrigatório'),
  status: Yup.number()
    .typeError('Campo obrigatório')
    .required('Campo obrigatório'),
});

const GroupChildForm = ({
  onSubmit,
  initialValues = formInitialValues,
  submitText,
  handleBack,
  isLoading,
}) => {
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={schema}
      onSubmit={onSubmit}
      validateOnBlur
      enableReinitialize
      render={() => {
        return (
          <Form>
            <Card style={{ padding: 20 }}>
              <InputContainer>
                <InputItem>
                  <Field name="name" label="Nome" component={CustomTextField} />
                </InputItem>
                <InputItem>
                  <Field
                    name="status"
                    label="Status"
                    options={[
                      { id: 0, name: 'Inativo' },
                      { id: 1, name: 'Ativo' },
                    ]}
                    component={CustomSelect}
                    placeholder="Status"
                    isLoading={false}
                  />
                </InputItem>
              </InputContainer>
              <FormButtons
                isLoading={isLoading}
                handleBack={handleBack}
                submitText={submitText}
              />
            </Card>
          </Form>
        );
      }}
    />
  );
};

GroupChildForm.propTypes = {
  onSubmit: PropTypes.func,
  initialValues: PropTypes.oneOfType([PropTypes.object]),
  submitText: PropTypes.string,
  handleBack: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  isLoading: PropTypes.bool.isRequired,
};

GroupChildForm.defaultProps = {
  initialValues: formInitialValues,
  submitText: 'Salvar',
  handleBack: false,
  onSubmit: () => {},
};

export default GroupChildForm;
